import React from 'react';

import cn from 'classnames';

import cls from './EmptyListItemsPlaceholder.module.css';

interface IEmptyListItemsPlaceholder {
    header?: React.ReactNode;
    main?: React.ReactNode;
    footer?: React.ReactNode;
    className?: string;
}

export const EmptyListItemsPlaceholder = ({
    header,
    main,
    footer,
    className,
}: IEmptyListItemsPlaceholder) => (
    <section className={cn(cls.EmptyListItemsPlaceholder, className)}>
        <header className={cls.header}>{header}</header>
        <main className={cls.main}>{main}</main>
        <footer className={cls.footer}>{footer}</footer>
    </section>
);
